import { ExcelExportParameters } from '@scts/models';

export const appealsExcelExportParams: ExcelExportParameters = {
  tableHeaders: [
    "Date Received",
    "Reference",	
    "Appeal Type",	
    "Appeal Subtype",	
    "Appellant",	
    "Representative",	
    "Respondent",	
    "Address",	
    "Valuation Roll Reference",
    "Assessor Reference",	
    "Property Type",	
    "Net Annual Value",	
    "Rateable Value",	
    "Effective Date",		
    "Appeal Reason",
  ],
  typeOfData: "appeals",
  tableColumnsWidth: [22, 22, 22, 16, 16, 22, 22, 30, 22, 22, 16, 16, 16, 16, 30],
}